var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group breadcrumb-container"},[_c('div',{staticClass:"breadcrumb-inner"},[_c('app-breadcrumb',{staticClass:"breadcrumb p-0",attrs:{"items":_vm.breadcrumbItems}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }